import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { BookingService } from "./booking.service";
import { BehaviorSubject, forkJoin } from "rxjs";
import { ICategories, TotalCategories } from "../dashboard/dashboard.model";
import { StarConvertService } from "./../../helpers/star-convertor.service";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import {
  BookingDetails,
  BookingsData,
  statusMapping,
  bookingGridColumns,
  praxisBookingGridColumns,
  IBookingsGridResponse,
} from "./booking.models";
import { MatTableDataSource } from "@angular/material/table";
``;
import { MatDateRangePicker } from "@angular/material/datepicker";
import { PaginationService } from "../../helpers/pagination.service";
import { CommonService } from "../../helpers/common.service";
import { Sort } from "@angular/material/sort";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DateConverterService } from "../../helpers/date-converter.service";
import { companies } from "../../models/company.model";

@Component({
  selector: "app-bookings",
  templateUrl: "./bookings.component.html",
  styleUrl: "./bookings.component.scss",
})
export class BookingsComponent implements OnInit, AfterViewInit {
  bookingForm: FormGroup;
  minDate: Date;
  maxDate: Date;
  startDate: Date;
  endDate: Date;
  bCategories: ICategories[] = []; // Replace with actual categories
  bStores: ICategories[] = []; // Replace with actual categories
  bStatuses: ICategories[] = []; // Replace with actual categories
  isAllSelected: boolean = false;
  mappedCategories: {
    name: string; // Name from TotalCategories
    value: string | number; // Value from dataObject using keyMap
  }[];
  mappedStores: {
    name: string; // Name from TotalCategories
    value: string | number; // Value from dataObject using keyMap
  }[];
  mappedStatus: {
    name: string; // Name from TotalCategories
    value: string | number; // Value from dataObject using keyMap
  }[];
  totalCategories = TotalCategories;
  mappedCategoriesCount: {
    name: string; // Name from TotalCategories
    value: string | number; // Value from dataObject using keyMap
  }[];

  resultsLength = 0;
  resultsLen = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  isFetching = false;
  displayedColumns: string[] = [];

  dataSource = new MatTableDataSource<any>();
  mappedBookings: BookingsData[] = [];
  sortedData: BookingsData[] = [];

  defaultCategory: number[];
  defaultStore: number[];
  defaultStatus: number[];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  isBookingOverview: boolean;
  bookingDetails: BookingDetails | null = null; // Initialize as null
  currentOffset: number = 0;
  selectedCategoryIds: number[];
  selectedStoreIds: number[];
  selectedStatusIds: number[];
  isLoading: boolean;
  totalBookingsCount: number = 0;
  companyId: number = 0;
  companyOrgId: number = 0;

  bookingDetails$ = new BehaviorSubject<BookingDetails | null>(null);

  @ViewChild("bookingPicker") bookingPicker!: MatDateRangePicker<Date>;

  pageLimit = 1000;
  currentPageSize: number = 100;
  currentPageIndex: number = 0;
  sortOrder: string = "desc";
  columnName: string;
  matSort: any;
  pageSize: number;
  isExecutionDate: boolean;
  whichGraph : boolean = true;
  showServiceType: boolean = true;
  showCharts: boolean = true;
  showStore: boolean = true;
  storeSearchTerm: string = '';
  filteredStores: { storeId: number; name: string }[] = [];
  isStoresLoading: boolean = true;
  isStoreSearchFocused: boolean = false;

  // Hide label when search input is focused
  hidelabel(): void {
    this.isStoreSearchFocused = true;
  }

  // Show label when search input loses focus
  showlabel(): void {
    this.isStoreSearchFocused = false;
  }

  // Filter stores based on search term
  filterStores(event: any): void {
    const searchTerm = event.target.value.toLowerCase();
    this.storeSearchTerm = event.target.value;
    
    // Get currently selected store IDs from form control (use 'bookingStore' for bookings)
    const selectedStoreIds = this.bookingForm.controls['bookingStore'].value || [];
    
    // Filter stores based on search term
    const filtered = this.bStores.filter((store: any) =>
      store.name.toLowerCase().includes(searchTerm)
    );
    
    // Always include already selected stores in the list (even if they don't match search)
    const selectedStores = this.bStores.filter((store: any) => 
      selectedStoreIds.includes(store.storeId)
    );
    
    // Merge filtered results with selected stores (avoiding duplicates)
    const selectedIds = new Set(filtered.map((s: any) => s.storeId));
    const additionalSelected = selectedStores.filter((s: any) => !selectedIds.has(s.storeId));
    
    this.filteredStores = [...filtered, ...additionalSelected];
  }

  // Clear search and show all stores
  clearStoreSearch(): void {
    this.storeSearchTerm = '';
    this.filteredStores = [...this.bStores];
  }

  openDatePicker(): void {
    this.bookingPicker.open();
  }

  constructor(
    private fb: FormBuilder,
    private bookingService: BookingService,
    private commonService: CommonService,
    private starConvertService: StarConvertService,
    private changeDetectorRef: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
    private paginationService: PaginationService,
    private dateConverterService: DateConverterService
  ) {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const currentDate = new Date().getDate();
    this.minDate = new Date(2022, 9, 93); // Default October 1st, 2022
    this.maxDate = new Date(currentYear, currentMonth, currentDate);
  }

  ngOnInit(): void {
    const companyIdval = localStorage.getItem("companyId");
    this.companyId = companyIdval ? Number.parseInt(companyIdval, 10) : 0;
    const companyOrgval = localStorage.getItem("companyOrg");
    this.companyOrgId = companyOrgval ? Number.parseInt(companyOrgval, 10) : 0;
    
    const company = companies.find(c => c.id === this.companyId);
    this.minDate = company?.minDate || this.minDate; // Use company-specific minDate if available
    this.showServiceType = company?.showServiceType ?? true; // Use company-specific showServiceType if available
    this.showCharts = company?.showCharts ?? true; // Use company-specific showCharts if available
    this.showStore = company?.showStore ?? true; // Use company-specific showStore if available

    this.displayedColumns =
      this.companyId != 4 ? bookingGridColumns : praxisBookingGridColumns;

    if (this.companyId != 4) {
      this.displayedColumns =
        this.companyOrgId === 3
          ? [...bookingGridColumns]
          : bookingGridColumns.filter((col) => col !== "taskId");
    } else {
      this.displayedColumns =
        this.companyOrgId === 3
          ? [...praxisBookingGridColumns]
          : praxisBookingGridColumns.filter((col) => col !== "taskId");
    }

    // Remove serviceType column for now, until flooring services is in place
     if (this.companyOrgId !== 3)
       this.displayedColumns = this.displayedColumns.filter(
         (col) => col !== "serviceType",
       );

    this.initializeDefaultBookingDates();
    this.createBookingForm();
    this.loadInitialData();
    const paginationState = this.paginationService.getPaginationState();
    if (paginationState) {
      this.currentPageIndex = paginationState.pageIndex;
      this.currentPageSize = paginationState.pageSize;
    }
  }

  filterDates(d: Date | null): boolean {
    return this.commonService.filterDates(d);
  }

  createBookingForm() {
    this.bookingForm = this.fb.group({
      startDate: [this.startDate, Validators.required],
      endDate: [this.endDate, Validators.required],
      bookingCategory: [null, Validators.required],
      bookingStore: [null, Validators.required],
      bookingStatus: [null, Validators.required],
      enableExecutionDate : [false]
    });
  }

  loadInitialData() {
    this.isStoresLoading = true;
    forkJoin({
      bookingsCategories: this.commonService.getCategories(this.companyId),
      bookingsStores: this.commonService.getStores(this.companyId),
      bookingsStatuses: this.commonService.getStatuses(),
    }).subscribe({
      next: ({ bookingsCategories, bookingsStores, bookingsStatuses }) => {
        this.bCategories = Array.isArray(bookingsCategories)
          ? bookingsCategories
          : Object.keys(bookingsCategories);
        this.bStores = Array.isArray(bookingsStores)
          ? bookingsStores
          : Object.keys(bookingsStores);
        this.bStatuses = Array.isArray(bookingsStatuses)
          ? bookingsStatuses
          : Object.keys(bookingsStatuses);

        this.defaultCategory = this.bCategories.map((cat) => cat.id);
        this.defaultStore = this.bStores.map((store) => store.storeId);
        this.defaultStatus = this.bStatuses.map((status) => status.id);
        // Handle the booking categories
        if (bookingsCategories && Object.keys(bookingsCategories).length) {
          this.bookingForm.controls["bookingCategory"].setValue([
            ...this.defaultCategory,
          ]);
          this.isAllSelected = true;
        }

        // Handle the booking stores
        if (bookingsStores && Object.keys(bookingsStores).length) {
          this.bookingForm.controls["bookingStore"].setValue([
            ...this.defaultStore,
          ]);
          this.isAllSelected = true;
        // Initialize filtered stores for search
          this.filteredStores = this.bStores;
          this.isStoresLoading = false;
        }

        // Handle the booking status
        if (bookingsStatuses && Object.keys(bookingsStatuses).length) {
          this.bookingForm.controls["bookingStatus"].setValue([
            ...this.defaultStatus,
          ]);
          this.isAllSelected = true;
        }
        // Call getAllBookingOverview API with default values after dropdowns are initialized
        this.fetchPaginatedData(
          this.currentOffset,
          this.defaultCategory,
          this.defaultStore,
          this.defaultStatus,
          this.columnName,
          this.sortOrder
        );
      },
      error: (error) => {
        console.error("Error loading initial data:", error);
      },
    });
  }

  initializeDefaultBookingDates() {
    this.startDate = new Date(new Date().getFullYear(), 0, 1); // Start: Jan 1st of current year
    this.endDate = new Date(); // End: today
  }

  resetData() {
    this.currentOffset = 0;
    this.resultsLength = 0;
    this.resultsLen = 0;
    this.mappedBookings = [];
    this.dataSource.data = [];
  }

  getCommonDetails(selectedIds: any, allCategoryDetails: any) {
    switch (true) {
      // "All" is selected & No categories selected
      case selectedIds.includes(0):
        this.isAllSelected = true;
        if (selectedIds.length === allCategoryDetails.length - 1) {
          const selectedIdsVal: number[] = selectedIds;
          selectedIds = selectedIdsVal.filter((n) => n !== 0);
        } else {
          selectedIds = [...allCategoryDetails];
        }

        break;
      // No Categories selected
      case selectedIds.length === allCategoryDetails.length - 1 &&
        !selectedIds.includes(0) &&
        this.isAllSelected === false:
        this.isAllSelected = true;
        selectedIds = [...allCategoryDetails];
        break;
      // All categories except "All" are selected
      case selectedIds.length === allCategoryDetails.length - 1 &&
        !selectedIds.includes(0) &&
        this.isAllSelected === true:
        this.isAllSelected = false;
        selectedIds = [];
        break;
      // Default: Other cases (some categories selected)
      default:
        this.isAllSelected = false;
        break;
    }
    return selectedIds;
  }

  // Handle the selection change
  onCategorySelectionChange(event: any): void {
    const selectedCategoryIds: number[] = event.value;
    this.resetData();
    const selectedCategories = this.getCommonDetails(
      selectedCategoryIds,
      this.defaultCategory
    );
    // Set the selected categories in the form control
    this.bookingForm.controls["bookingCategory"].setValue(selectedCategories);
    // Make a single call to the API with the selected categories, stores, and status
    this.loadBookingGridData(
      this.currentOffset,
      selectedCategories,
      this.selectedStoreIds,
      this.selectedStatusIds,
      this.columnName,
      this.sortOrder,
      this.bookingForm.controls["enableExecutionDate"].getRawValue()
    );
  }

  onStoreSelectionChange(event: any): void {
    const selectedStoreIds: number[] = event.value;
    this.resetData();
    const selectedStores = this.getCommonDetails(
      selectedStoreIds,
      this.defaultStore
    );
    // Set the selected stores in the form control
    this.bookingForm.controls["bookingStore"].setValue(selectedStores);
    // Make a single call to the API with the selected categories, stores, and status
    this.loadBookingGridData(
      this.currentOffset,
      this.selectedCategoryIds,
      selectedStores,
      this.selectedStatusIds,
      this.columnName,
      this.sortOrder
    );
  }

  onStatusSelectionChange(event: any): void {
    const selectedStatusIds: number[] = event.value;
    this.resetData();
    const selectedStatus = this.getCommonDetails(
      selectedStatusIds,
      this.defaultStatus
    );
    // Set the selected statuses in the form control
    this.bookingForm.controls["bookingStatus"].setValue(selectedStatus);
    // Make a single call to the API with the selected statuses, stores, and status
    this.loadBookingGridData(
      this.currentOffset,
      this.selectedCategoryIds,
      this.selectedStoreIds,
      selectedStatus,
      this.columnName,
      this.sortOrder
    );
  }

  // Compare categories based on their ID
  compare(category1: any, category2: any): boolean {
    return category1 && category2
      ? category1 === category2
      : category1 === category2;
  }

  loadBookingGridData(
    offset: number,
    selectedCategory?: any,
    selectedStores?: any,
    selectedStatus?: any,
    columnName?: any,
    sortOrder?: any,
    execDateflag?: boolean
  ) {
    this.fetchPaginatedData(
      offset,
      selectedCategory,
      selectedStores,
      selectedStatus,
      columnName,
      sortOrder,
      execDateflag
    );
  }

    // Compare stores based on their ID (handles comparison between storeId and store object)
  compareStores(store1: any, store2: any): boolean {
    // store1 is the value from form control (storeId number)
    // store2 is the store object from the list
    if (store1 === null || store1 === undefined || store2 === null || store2 === undefined) {
      return false;
    }
    // Get the actual ID to compare
    const id1 = typeof store1 === 'number' ? store1 : Number.parseInt(store1, 10);
    const id2 = store2.storeId !== undefined ? store2.storeId : (typeof store2 === 'number' ? store2 : Number.parseInt(store2, 10));
    return id1 === id2;
  }

  
  capitalizeFirstLetter(str: string): string {
    if (!str) {
      return str;
    }
    // This handles simple camelCase to TitleCase (e.g., 'serviceType' -> 'ServiceType')
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // For Pagination Call after reaching offset of 1000
  fetchPaginatedData(
    pageSize?: number,
    selectedCategory?: any,
    selectedStores?: any,
    selectedStatus?: any,
    columnName?: any,
    sortOrder?: any,
    execDateflag?: boolean
  ) {
    if (this.isFetching) return;
    this.isFetching = true;
    this.selectedCategoryIds = selectedCategory;
    this.selectedStoreIds = selectedStores;
    this.selectedStatusIds = selectedStatus;
    const offset = this.dataSource.data.length; // Calculate offset based on current data length
    this.dataSource.sort = this.sort;
    // this.pageSize = offset;
    const body = {
      CategoryIds: this.selectedCategoryIds,
      StoreIds: this.selectedStoreIds,
      Statuses: this.selectedStatusIds,
      startDate: this.bookingForm.controls["startDate"].value || null,
      endDate: this.bookingForm.controls["endDate"].value || null,
      pageOffset: this.paginator.pageIndex * this.paginator.pageSize,
      pageLimit: this.pageLimit,
      companyId: this.companyId,
      columnName: columnName
        ? this.capitalizeFirstLetter(columnName)
        : "TaskId",
      sortOrder: sortOrder,
      execDateflag: this.bookingForm.controls["enableExecutionDate"].getRawValue() || false,
    };
    if (!body.startDate || !body.endDate) {
      return;
    }
    this.bookingService
      .getAllSortBookingOverview(body)
      .subscribe((bookings: IBookingsGridResponse) => {
        if (bookings && bookings.value.bookingsOverview.length > 0) {
          this.totalBookingsCount = bookings.value.bookingsOverviewCount;
          this.resultsLength = bookings.value.bookingsOverviewCount;
          this.mappedBookings = bookings.value.bookingsOverview.map((booking, index) => {
            const startingIndex = index + offset;
            let starRating = "";
            let ratingMessage = "";

            if (booking.rating < 0) {
              ratingMessage = "-";
            } else {
              starRating = this.starConvertService.convertDecimalNumberToStars(
                booking.rating
              );
            }
            return {
              ...booking,
              statusName: this.getStatusName(booking.status), // Assuming 'status' is the ID
              starRating,
              ratingMessage,
              number: startingIndex + 1,
            };
          });

          // Append new data to the existing data
          this.dataSource.data = [
            ...this.dataSource.data,
            ...this.mappedBookings,
          ];
          this.resultsLen = this.resultsLen + this.mappedBookings.length; // Update the total length of the data
          // Attach paginator and sorting after data is updated
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

          const startIndex = this.currentPageIndex * this.currentPageSize;
          const endIndex = startIndex + this.currentPageSize;
          this.paginator.length = this.totalBookingsCount;

          this.sortedData = this.dataSource.data.slice(startIndex, endIndex);
          // this.paginator.length = this.totalBookingsCount;
          this.sortCurrentPageData(); // Apply sorting after fetching data
        } else {
          this.sortedData = [];
          this.changeDetectorRef.detectChanges();
          this.isFetching = false;
        }
        this.isFetching = false; // Stop loading spinner
      });
  }

  handleSortChange(event: Sort) {
    this.dataSource.data = [];
    this.resultsLen = 0;
    // 'sortState.active' will give you the `matColumnDef` name of the sorted column
    // 'sortState.direction' will give you the sort direction ('asc', 'desc', or '')
    // You can use these values for various purposes, for example:
    // 1. If you're doing server-side sorting:
    //    Call your API with sortState.active and sortState.direction to get sorted data.
    // 2. For custom client-side sorting:
    //    Implement your own sorting logic based on these values (though MatTableDataSource
    //    often handles basic client-side sorting automatically once `dataSource.sort` is set).
    if (event.active && event.direction) {
      this.loadBookingGridData(
        this.currentOffset,
        this.selectedCategoryIds,
        this.selectedStoreIds,
        this.selectedStatusIds,
        event.active,
        event.direction,
        this.bookingForm.controls["enableExecutionDate"].getRawValue()
      );
    } 
    else {
      //TODO remove after testing
      // this._snackBar.open("Sorting is been cleared", "Close", {
      //   duration: 3000,
      //   horizontalPosition: "center",
      //   verticalPosition: "top",
      // });
    }
  }

  // Apply sorting logic to current page's data
  sortCurrentPageData() {
    if (this.sort.active && this.sort.direction !== "") {
      const startIndex = this.currentPageIndex * this.currentPageSize;
      const endIndex = startIndex + this.currentPageSize;
      this.paginator.length = this.totalBookingsCount;

      // TODO: Remove after testing
      // Slice data for current page and apply sorting
      // const currentPageData = this.dataSource.data.slice(startIndex, endIndex);
      // this.sortedData = currentPageData.sort((a, b) => {
      //   const isAsc = this.sort.direction === "asc";
      //   const isDesc = this.sort.direction === "desc";
      //   switch (this.sort.active) {
      //     case "status":
      //       return this.sorting(a.status, b.status, isAsc);
      //     // case "number":
      //     //   return this.sorting(a.number, b.number, isAsc);
      //     case "rating":
      //       return this.sorting(a.rating, b.rating, isAsc);
      //     case "serviceType":
      //       return this.sorting(a.serviceType, b.serviceType, isAsc);
      //     case "taskId":
      //       return this.sorting(a.taskId, b.taskId, isAsc);
      //     case "city":
      //       return this.sorting(a.city, b.city, isAsc);
      //     case "store":
      //       return this.sorting(a.city, b.city, isAsc);
      //     case "leadTime":
      //       return this.sorting(a.leadTime, b.leadTime, isAsc);
      //     case "orderValue":
      //       return this.sorting(a.orderValue, b.orderValue, isAsc);
      //     case "leadFee":
      //       return this.sorting(a.leadFee, b.leadFee, isAsc);
      //     case "hasWarrantyRequest":
      //       return this.sorting(
      //         a.hasWarrantyRequest,
      //         b.hasWarrantyRequest,
      //         isAsc
      //       );
      //     case "executionDate":
      //       return this.sortingDate(
      //         this.parseDate(a.executionDate),
      //         this.parseDate(b.executionDate),
      //         isDesc
      //       );
      //     default:
      //       return 0;
      //   }
      // });
    }
  }

  onPageChange($event: PageEvent) {
    this.currentPageIndex = $event.pageIndex;
    this.currentPageSize = $event.pageSize;
    // Save the pagination state before navigating
    this.paginationService.savePaginationState(
      this.currentPageIndex,
      this.currentPageSize,
      this.resultsLen
    );
    const startIndex = this.currentPageIndex * this.currentPageSize;
    let endIndex = startIndex + this.currentPageSize;
    // let endIndexVal = endIndex;
    if (endIndex > this.totalBookingsCount) {
      endIndex = this.totalBookingsCount;
    }
    this.paginator._intl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ) => {
      return `${startIndex + 1} - ${endIndex} of ${this.totalBookingsCount}`;
    };

    this.sortedData = this.dataSource.data.slice(startIndex, endIndex);
    this.sortCurrentPageData(); // Apply sorting after fetching data

    if (
      $event.pageIndex * $event.pageSize ==
      this.resultsLen - $event.pageSize
    ) {
      this.fetchPaginatedData(
        $event.pageSize,
        this.selectedCategoryIds,
        this.selectedStoreIds,
        this.selectedStatusIds,
        this.columnName,
        this.sortOrder
      );
    } else {
      // Attach paginator and sorting after data is updated
      this.dataSource.paginator = this.paginator;
    }
    // Check if the user has reached near the end and needs to load more data
    const offsetReached = ($event.pageIndex + 1) * $event.pageSize;
    const isNearEnd = offsetReached >= this.dataSource.data.length;
  }

  //on Date Change
  onDateRangeChange() {
    this.resetData();
    this.currentOffset = 0;
    this.isFetching = false;
    if (
      (this.maxDate !== null && this.minDate !== null) ||
      (this.maxDate > this.minDate &&
        this.companyId !== null &&
        this.selectedCategoryIds !== null)
    ) {
      if (
        this.minDate.getTime() === this.startDate.getTime() &&
        this.maxDate.getTime() === this.endDate.getTime()
      ) {
        this.loadBookingGridData(
          this.currentOffset,
          this.selectedCategoryIds,
          this.selectedStoreIds,
          this.selectedStatusIds,
          this.columnName,
          this.sortOrder,
          this.bookingForm.controls["enableExecutionDate"].getRawValue()
        );
      } else {
        this.startDate = this.minDate;
        this.endDate = this.maxDate;
        this.loadBookingGridData(
          this.currentOffset,
          this.selectedCategoryIds,
          this.selectedStoreIds,
          this.selectedStatusIds,
          this.columnName,
          this.sortOrder,
          this.bookingForm.controls["enableExecutionDate"].getRawValue()
        );
      }
    }
  }

  ngAfterViewInit() {
    // Ensure sorting works by listening to sort changes
    this.sort.sortChange.subscribe(() => {
      this.sortCurrentPageData();
    });
    if (this.matSort) {
      this.dataSource.sort = this.matSort;
    }
  }

  // Mapping status id to corresponding name
  getStatusName(statusId: string): string {
    const status = statusMapping.find((item) => item.id === statusId);
    return status ? status.name : "Unknown";
  }

  // Apply filter for searching (optional)
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    // After applying filter, sort the visible data
    this.sortCurrentPageData();
  }

  // Custom comparison function
  sorting(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortingDate(
    a: number | string | Date,
    b: number | string | Date,
    isAsc: boolean
  ) {
    // Convert string dates to Date objects if they are not already
    const dateA = new Date(a);
    const dateB = new Date(b);

    // Compare the dates
    return (dateA.getTime() - dateB.getTime()) * (isAsc ? 1 : -1);
  }

  parseDate(dateString: string): Date {
    const [day, month, year] = dateString.split("-").map(Number); // Split the string and convert to numbers
    return new Date(year, month - 1, day); // Create a Date object (month is zero-based)
  }

  overview(taksid: number): any {
    // Save the current page state before navigation
    this.paginationService.savePaginationState(
      this.currentPageIndex,
      this.currentPageSize,
      this.resultsLen
    );

    this.isLoading = true;
    this.bookingService
      .getBookingDetailsByTask(taksid, this.companyId)
      .subscribe(
        (details: BookingDetails) => {
          this.bookingDetails = details;
          this.bookingService.bookingOverviewDetails.next(details);
          this.isBookingOverview = true;
          this.isLoading = false;
          this.changeDetectorRef.detectChanges();
        },
        (error) => {
          this._snackBar.open(
            "Some thing went wrong while load Booking details. Please try again...",
            "Close",
            {
              duration: 3000,
              horizontalPosition: "center",
              verticalPosition: "top",
            }
          );
          return;
        }
      );
  }

  isBookingsData(event: any) {
    this.isBookingOverview = !this.isBookingOverview;
    // Restore pagination state if returning to the list view
    if (!this.isBookingOverview) {
      const savedState = this.paginationService.getPaginationState();

      if (savedState && this.paginator) {
        this.currentPageIndex = savedState.pageIndex;
        this.currentPageSize = savedState.pageSize;
        this.resultsLen = this.totalBookingsCount;

        this.paginator.pageIndex = this.currentPageIndex;
        this.paginator.pageSize = this.currentPageSize;
        this.paginator.length = this.totalBookingsCount;

        this.fetchPaginatedData(
          this.currentPageSize,
          this.selectedCategoryIds,
          this.selectedStoreIds,
          this.selectedStatusIds
        );
      }
    }
  }

  //Display respective name for the retreived status id
  getStatusClass(statusName: string): string {
    return this.commonService.getStatusClass(statusName);
  }

  //Attach Icons for Status
  getStatusIcon(statusName: string): string {
    return this.commonService.getStatusIcon(statusName);
  }

  isExecutionDateEnabled(isEnabled:boolean) {
    this.dataSource.data = [];
     this.resultsLen = 0;
    if (isEnabled) {
      this.isExecutionDate = true
      this.loadBookingGridData(
        this.currentOffset,
        this.selectedCategoryIds,
        this.selectedStoreIds,
        this.selectedStatusIds,
        this.columnName,
        this.sortOrder,
        isEnabled
      );
      // return booking.receiveDate > this.startDate && booking.receiveDate < this.endDate;
    }
    else {
      this.isExecutionDate = false;
      this.loadBookingGridData(
        this.currentOffset,
        this.selectedCategoryIds,
        this.selectedStoreIds,
        this.selectedStatusIds,
        this.columnName,
        this.sortOrder,
        isEnabled
      );
      // this.sortedData = this.dataSource.data; // Reset to original data if not enabled
      }
    // this.bookingForm.patchValue({ executionDate: isEnabled ? new Date() : null });
    // this.bookingForm.patchValue({ executionDate: isEnabled ? new Date() : null });
  }
}
